module.exports = __webpack_public_path__ + "assets/group-white.ad6c7143.svg";